module.exports = __webpack_public_path__ + "static/media/cs-logo.3bb9c6de.png";